module.exports = function reducer_Moment(state = null) {
    return state;
};
